import { settleMount } from "#ce/framework/mount-ready";

/**
 * Returns an async Done callback that registers and saves the number, then closes the dialog.
 * Waits for call-tracking updates when initialized before saving and closing.
 * Waits for a workflow sp-select to mount, leaving the dialog open if mounting fails.
 * Registration failures display the server's errors and leave the dialog open.
 *
 * @param {object} options
 * @returns {() => Promise<void>}
 */
export function createTelephoneDialogSave({
  dialog,
  callTrackingInitialized,
  callTrackingManager,
  registerNumber,
  save,
  remove,
}) {
  return async function saveTelephoneDialog() {
    const numberInput = dialog.querySelector("[name=number]");
    const trackingInput = dialog.querySelector("[name=tracking]");
    const workflowInput = dialog.querySelector("[name=workflow]");
    const errorElement = dialog.querySelector(".error");

    if (workflowInput?.matches("sp-select") && !(await settleMount(workflowInput))) {
      return;
    }

    errorElement.innerHTML = "";

    let data;

    try {
      data = await registerNumber(numberInput.value);
    } catch (response) {
      errorElement.innerHTML = response.responseJSON.errors;

      return;
    }

    if (callTrackingInitialized) {
      await callTrackingManager.update(data.number, {
        original_number_id: data.id,
        original_local_number: data.local_number,
        wants_local_number: data.wants_local_number,
        enabled: trackingInput.checked,
        workflow_id: workflowInput && workflowInput.value,
      });
    }

    save(data);
    remove();
  };
}
